interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  noIndex?: boolean;
  canonicalUrl?: string;
  structuredData?: object;
  author?: string;
  publishedTime?: string;
  modifiedTime?: string;
}

export function SEOHead({
  title = 'PesaJet Pay - Mobile Money Payment Gateway Uganda | MTN & Airtel Integration',
  description = "Accept mobile money payments from MTN and Airtel in Uganda and East Africa with PesaJet Pay's unified API. Built by PesaJet (evolved from E-Moments Tech Enterprise, founded by Emily Sonia Nakabuye). Simple integration, real-time processing, and transparent 2.5% pricing.",
  keywords = 'emoments, e-moments, E-Moments, E-Moments Tech Enterprise, PesaJet Pay, PesaJet, Emily Sonia Nakabuye, Women in FinTech, HiPipo, @pesajet/sdk, payment gateway Uganda, online payment gateway, mobile money payment gateway, payment API, payments API integration, payment gateway integration, MTN Mobile Money Uganda, MTN MoMo API, Airtel Money Uganda, Airtel Money API, merchant payments, business payments, payment collection, payment disbursement, fintech Uganda, ShulePay integration, East Africa payments',
  image = 'https://pay.pesajet.com/og-image.png',
  url = 'https://pay.pesajet.com/',
  type = 'website',
  noIndex = false,
  canonicalUrl,
  structuredData,
  author = 'PesaJet Pay',
  publishedTime,
  modifiedTime,
}: SEOHeadProps) {
  const fullTitle = title.includes('PesaJet Pay') ? title : `${title} | PesaJet Pay`;
  const currentUrl = canonicalUrl || url;

  return (
    <>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />

      {/* Robots */}
      <meta name="robots" content={noIndex ? 'noindex, nofollow' : 'index, follow'} />

      {/* Canonical URL */}
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:secure_url" content={image} />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta
        property="og:image:alt"
        content="PesaJet Pay - Unified Mobile Money Gateway for MTN MoMo and Airtel Money"
      />
      <meta property="og:site_name" content="PesaJet Pay" />
      <meta property="og:locale" content="en_US" />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={currentUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      <meta property="twitter:creator" content="@pesajetpay" />
      <meta property="twitter:site" content="@pesajetpay" />

      {/* Additional SEO Meta Tags */}
      <meta name="theme-color" content="#f5f4ef" />
      <meta name="msapplication-TileColor" content="#f5f4ef" />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      )}
    </>
  );
}
